import { apiInstance } from '@diamond/shared/utils';

export interface DailyStockImportResponse {
  success: boolean;
  message: string;
  data: {
    imported_count: number;
  };
}

const IMPORT_ENDPOINT =
  '/backoffice/master-data/product-daily-order-limit-configurations/import';
const EXPORT_ENDPOINT =
  '/backoffice/master-data/product-daily-order-limit-configurations/export';
export const EXPORT_FILENAME = 'product_daily_order_limit_configurations.xlsx';

export const importDailyStock = async (
  token: string,
  file: File
): Promise<DailyStockImportResponse> => {
  const formData = new FormData();
  formData.append('file', file, file.name);

  const response = await apiInstance(token, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).post<DailyStockImportResponse>(IMPORT_ENDPOINT, formData);

  return response.data;
};

export const exportDailyStock = async (token: string): Promise<Blob> => {
  const response = await apiInstance(token, {
    responseType: 'blob',
  }).get<Blob>(EXPORT_ENDPOINT);

  return response.data;
};
